import { render } from "./List.vue?vue&type=template&id=5f4a7bbf"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/bylex_platform/cwt2/alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Projects/List.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f4a7bbf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f4a7bbf', __exports__)) {
    api.reload('5f4a7bbf', __exports__)
  }
  
  module.hot.accept("./List.vue?vue&type=template&id=5f4a7bbf", () => {
    api.rerender('5f4a7bbf', render)
  })

}


export default __exports__